import { render, staticRenderFns } from "./EmployeeHorizontalMenu.vue?vue&type=template&id=4190cfdd&scoped=true"
import script from "./EmployeeHorizontalMenu.vue?vue&type=script&lang=js"
export * from "./EmployeeHorizontalMenu.vue?vue&type=script&lang=js"
import style0 from "./EmployeeHorizontalMenu.vue?vue&type=style&index=0&id=4190cfdd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4190cfdd",
  null
  
)

export default component.exports